import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function PolazisteIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PolazisteIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <circle fill="#FFFFFF" cx="50" cy="50" r="26.8" />
      <path fill="#FF0000" d="M50,27c-12.682,0-23,10.318-23,23c0,10.498,7.072,19.369,16.7,22.115l1.299-4.559
	C37.352,65.374,31.731,58.338,31.731,50c0-10.074,8.196-18.269,18.269-18.269S68.269,39.927,68.269,50
	c0,8.338-5.621,15.374-13.268,17.556l1.299,4.559C65.928,69.369,73,60.498,73,50C73,37.318,62.682,27,50,27z"/>
      <circle fill="#FF0000" cx="50" cy="50" r="10.569" />
    </svg>
  </SvgIcon>
}

export default PolazisteIcon;
